'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _qrcode = require('qrcode');

var _qrcode2 = _interopRequireDefault(_qrcode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Render the QR
var QR = function (_Component) {
    _inherits(QR, _Component);

    function QR(props) {
        _classCallCheck(this, QR);

        var _this = _possibleConstructorReturn(this, (QR.__proto__ || Object.getPrototypeOf(QR)).call(this, props));

        _this.state = { qr: '' };
        return _this;
    }

    _createClass(QR, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setQR();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props !== prevProps) this.setQR();
        }
    }, {
        key: 'setQR',
        value: function setQR() {
            var _this2 = this;

            // Get all the data from the props
            var _props = this.props,
                cell = _props.cell,
                name = _props.name,
                tel = _props.tel,
                url = _props.url;

            // Put the data in a vCard

            var card = 'BEGIN:VCARD\nN:' + (name ? name : '') + '\nTEL;CELL:' + (tel ? tel : '') + '\nTEL;voice:' + (cell ? cell : '') + '\nURL:' + (url ? url : '') + '\nEND:VCARD';

            // Set options for QR code
            var opts = {
                errorCorrectionLevel: 'L',
                type: 'image/jpeg',
                color: {
                    dark: this.props.color ? this.props.color : '#414042',
                    light: '#fff'
                },
                margin: 2,
                rendererOpts: { quality: 1 }

                // Create and set the QR code in a state
            };_qrcode2.default.toDataURL(card, opts).then(function (url) {
                return _this2.setState({ qr: url });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement('img', {
                alt: 'Scan our QR-code and add us to your contacts',
                src: this.state.qr,
                style: {
                    'backgroundColor': 'white',
                    'borderRadius': '5px',
                    'display': 'block',
                    'height': '' + this.props.height,
                    'margin': '5px',
                    'width': '' + this.props.width
                },
                title: 'Scan our QR-code and add us to your contacts'
            });
        }
    }]);

    return QR;
}(_react.Component);

exports.default = QR;